<div class="import-modal">

  <div *ngIf="rows.length == 0">
    <h2>er zijn geen transacties toegevoegd</h2>
    <div>
      <div>dit zijn de mogelijke oorzaken:</div>
      <ul>
        <li>dit bestand is al eerder geïmporteerd</li>
        <li>dit bestand bevat geen transacties van na de instellingsdatum van de belanghebbende</li>
      </ul>
    </div>
    <p>
      controleer de gegevens. indien deze niet juist zijn, gebruik dan onze chat rechtsonder om een gesprek te starten
      met een van onze medewerkers.
    </p>
    <button class="block float-right btn check accent inverted" (click)="ok(null)">akkoord</button>
  </div>

  <div *ngIf="rows.length > 0" class="centered-modal">
    <h2>de volgende banktransacties zijn geïmporteerd</h2>
    <p>
      De volgende rekening(en) zijn geïmporteerd. Controleer de gegevens. Indien deze niet juist zijn, gebruik dan onze chat rechtsonder om een gesprek te starten
      met een van onze medewerkers.
    </p>
    <table class="table">
      <tbody>
      <tr *ngFor="let row of rows">
        <td>
          <strong>{{row.account.accountCategory.name}}</strong> <br>
          {{row.account.accountNumber}}
        </td>
        <td>
          <strong>startdatum</strong>: {{row.startDate}} <br>
          <strong>startsaldo</strong>: {{currency.euro(row.startAmount)}}
        </td>
        <td>
          <strong>einddatum</strong>: {{row.endDate}} <br>
          <strong>eindsaldo</strong>: {{currency.euro(row.endAmount)}}
        </td>
        <td>
          <strong>geïmporteerd</strong>: {{row.added}} <br>
          <ng-container *ngIf="row.categorised != 0">
            <strong>gecategoriseerd</strong>: {{row.categorised}}
          </ng-container> &nbsp;
        </td>
      </tr>
      </tbody>
    </table>
    <div class="spacer-small"></div>
    <small class="block align-center">
      <strong>Let op: </strong> om een compleet rapport te krijgen dient u alle rekeningen die van toepassing zijn op
      dit bewind in te lezen.
    </small>
    <div class="spacer"></div>
    <div *ngIf="allDoneAndWell">
      <button class="block btn float-left arrow-left" (click)="ok(resultEnum.ImportAnotherFile)" >meer bankbestanden inlezen</button>
      <button class="block btn float-right check accent inverted" (click)="ok(resultEnum.CategorizeTransactions)" >transacties categoriseren</button>
    </div>
    <div *ngIf="!allDoneAndWell">
      <button class="block float-right btn check accent inverted" (click)="ok(null)">akkoord</button>
    </div>
    <div class="clearFix"></div>
  </div>
</div>
